import {
  GQLConfig,
  GQLProductVariant,
} from '~/graphql/__generated__/interfaces'
import { DetailModel } from '~/utils/domain/Detail'

export const getRrpPrice = (
  variant: GQLProductVariant | DetailModel,
  getConfig: GQLConfig
) => {
  if (
    !getConfig ||
    !variant ||
    Number(getConfig.shopConfig?.productOldPriceDisabled)
  ) {
    return null
  }

  return variant.discountPrice && variant.discountPrice > 0
    ? variant.priceRrp
    : 0
}

export const getDiscountLimit = (getConfig: GQLConfig) => {
  return Number(getConfig.shopConfig?.productBoxSaleBadgeLimitPercent) || null
}

export const getDiscountSource = (getConfig: GQLConfig) => {
  return getConfig.shopConfig?.productDiscountSource
}
